import { render, staticRenderFns } from "./RecentMessageList.vue?vue&type=template&id=eab486de"
import script from "./RecentMessageList.vue?vue&type=script&lang=js"
export * from "./RecentMessageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports